import { CarrierBillingAccountType } from "@redotech/congo-enums/carrier-billing-account-type";
import {
  billingAccountType,
  CarrierBillingAccount,
} from "@redotech/redo-fulfillment-carrier-account-common/carrier-billing-accounts";
import { t } from "@redotech/redo-i18n";
import { assertNever } from "@redotech/util/type";

/** What a rate billed to someone else's carrier account is labeled with. */
export function externalBillingBadgeText(
  billingAccount: CarrierBillingAccount | undefined,
): string {
  if (!billingAccount) {
    return t("3rd party billing");
  }
  if (billingAccount.accountName) {
    return billingAccount.accountName;
  }
  const type = billingAccountType(billingAccount);
  switch (type) {
    case CarrierBillingAccountType.Receiver:
      return t("Receiver billing");
    case CarrierBillingAccountType.ThirdParty:
      return t("3rd party billing");
    default:
      return assertNever(type);
  }
}
